namespace Matrix.Administration {
    export interface UserLogForm {
        Username: Serenity.StringEditor;
        LogDate: Serenity.DateEditor;
        LogTypeCode: Serenity.StringEditor;
        ClientAddress: Serenity.StringEditor;
        Path: Serenity.StringEditor;
        UserAgent: Serenity.StringEditor;
        Hash: Serenity.IntegerEditor;
        Counter: Serenity.IntegerEditor;
        Details: Serenity.TextAreaEditor;
    }

    export class UserLogForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.UserLog';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UserLogForm.init)  {
                UserLogForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.TextAreaEditor;

                Q.initFormType(UserLogForm, [
                    'Username', w0,
                    'LogDate', w1,
                    'LogTypeCode', w0,
                    'ClientAddress', w0,
                    'Path', w0,
                    'UserAgent', w0,
                    'Hash', w2,
                    'Counter', w2,
                    'Details', w3
                ]);
            }
        }
    }
}
